import { jsx } from "react/jsx-runtime";
import { btnWriteReview } from "./styles.js";
import { StandardView } from "./view.standard.js";
import { Button } from "../../Inputs/Button/index.js";
function InteractiveView({
  value,
  onRatingClick,
  reviewCount,
  displayAvgRatingAsText,
  displayReviewCount,
  ariaLabel,
  displayVariant,
  size,
  emptyReviewText
}) {
  return /* @__PURE__ */ jsx(
    Button,
    {
      onClick: onRatingClick,
      sx: btnWriteReview,
      variant: "text-button",
      "data-testid": "rating-review-button",
      children: /* @__PURE__ */ jsx(
        StandardView,
        {
          value,
          reviewCount,
          displayAvgRatingAsText,
          displayReviewCount,
          ariaLabel,
          displayVariant,
          size,
          emptyReviewText
        }
      )
    }
  );
}
export {
  InteractiveView
};
